import { call, takeEvery, put, select } from 'redux-saga/effects'
import { stopSubmit, change, startSubmit } from 'redux-form/immutable'

import { IDENTITY_UPLOAD_AVATAR_REQUEST } from '../actionTypes'
import { PROFILE_AVATAR_FORM_NAME } from 'app/constants/profile'
import { promisedCanvasToBlob } from 'helpers'
import { uploadFileToS3 } from 'store/entities/api/sagas/s3PolicySagas'
import { getIdentityUserData } from 'store/entities/identity/selectors'
import { saveProfile } from '../actions'

export function* uploadAvatarToS3(file, ext, formName) {
  yield put(startSubmit(formName))
  const avatarPath = yield call(uploadFileToS3, { file, ext, entity: 'users' })
  yield put(change(formName, 'avatar', avatarPath))
  if (formName === PROFILE_AVATAR_FORM_NAME) {
    const profileSettings = yield select(getIdentityUserData)
    yield saveProfile.call(profileSettings.set('avatar', avatarPath))
  }
  yield put(stopSubmit(formName))
}

export function* uploadAvatarToS3Flow(action) {
  // TODO: ext and mime not defined here, find a way revert it back
  const { file, ext, mime, formName } = action.payload
  if (file instanceof HTMLCanvasElement) {
    const blob = yield call(promisedCanvasToBlob, file, mime)
    yield call(uploadAvatarToS3, blob, ext, formName)
  } else {
    yield call(uploadAvatarToS3, file, file.name.substring(file.name.lastIndexOf('.') + 1), formName)
  }
}

export default function* watchUploadAvatarRequest() {
  yield takeEvery(IDENTITY_UPLOAD_AVATAR_REQUEST, uploadAvatarToS3Flow)
}
